import React, {Component} from "react";
import {Row, Col, Collapse} from 'reactstrap';
import {mapType} from '../../../../../utils/constants';
import '../Review.css';

export default class ReviewMatchColumns extends Component {

    constructor(props) {
       super(props);
       this.state = {
           isMatchedColumnOpened: false
       }
    }

    render() {
        let { orgChart, mapGender, type, mapPositions,mapPerformance,mapSeparation } = this.props;
        let {isMatchedColumnOpened} = this.state;
        let matchedColumn = '';
        let matchedColumns = [];
        let allColumnsLength = 0;
        // console.log(this.props, type);
        switch (type) {
            case mapType.orgChart:
                matchedColumn = orgChart.matchedColumn ? orgChart.matchedColumn : 0;
                allColumnsLength = orgChart.allColumns ? orgChart.allColumns.length : 0;
                break;
            case mapType.gender:
                matchedColumn = mapGender.matchedColumn ? mapGender.matchedColumn : '';
                allColumnsLength = mapGender.allColumns ? mapGender.allColumns.length : 0;
                break;
            case mapType.positions:
                // console.log(mapPositions.matchedColumns)
                let csvFieldsMatchColumns = mapPositions.matchedColumns ? mapPositions.matchedColumns : 0;
                // console.log(csvFieldsMatchColumns)
                // matchedColumns = csvFieldsMatchColumns.filter(matchedColumn => matchedColumn.value.length>0);
                // console.log(csvFieldsMatchColumns)
                matchedColumns = csvFieldsMatchColumns.map(matchedColumn => {
                    // console.log('matchedColumns---', matchedColumn)
                    return matchedColumn.csvField
                    // if(matchedColumn.value.length>0){
                    //     return matchedColumn.csvField;
                    // }
                })
                // console.log(matchedColumns)
                allColumnsLength = mapPositions.allColumns ? mapPositions.allColumns.length : 0;
                break;
            case mapType.performance:
                matchedColumn = mapPerformance.matchedColumn ? mapPerformance.matchedColumn : '';
                allColumnsLength = mapPerformance.allColumns ? mapPerformance.allColumns.length : 0;
                break;
            case mapType.separation:
                matchedColumn = mapSeparation.matchedColumn ? mapSeparation.matchedColumn : '';
                allColumnsLength = mapSeparation.allColumns ? mapSeparation.allColumns.length : 0;
                break;
            default:
                matchedColumns = 0;
                allColumnsLength = 0;
        }
        // console.log(matchedColumns);
        // console.log(matchedColumn);
        return (
            (type === mapType.orgChart || type === mapType.gender 
                || type === mapType.performance || type === mapType.separation) ?
                <div className="review-sub-section-heading">
                    <span>Matched column:</span><span style={{ fontWeight: '400' }}> {matchedColumn}</span>
                </div> :
                <div>
                    <Row>
                        <Col sm="11" md="11" className="review-sub-section-heading">Matched {matchedColumns.length} of {allColumnsLength} columns</Col>
                        <Col sm="1" md="1" className={isMatchedColumnOpened ? 'rotate-arrow' : 'text-center'}> 
                        <i className={(isMatchedColumnOpened ? 'flaticon-down-arrow ' : 'flaticon-down-arrow').concat(' review-flaticon-down-arrow cursor-pointer')}  
                            onClick={ () => {
                            this.setState({isMatchedColumnOpened : !isMatchedColumnOpened});
                        }}/>
                        </Col>
                    </Row>
                    <Collapse isOpen={isMatchedColumnOpened}>
                    <div className="mt30">
                        {matchedColumns.map((matchedColumn, index) => {
                            return (<div key={index+matchedColumn} className={'review-matched-column '.concat(index === 0 ? ' ': 'mt10')}>
                                <span>Matched column: </span>
                                <span style={{ fontWeight: '600' }}>{matchedColumn}</span>
                            </div>
                            )
                        })}
                    </div>
                    </Collapse>
                </div>)
    }
}
